/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerSeason = {
    properties: {
        text: {
            type: 'TranslationBase',
            isRequired: true,
        },
        value: {
            type: 'number',
            isRequired: true,
        },
        unit: {
            type: 'FrontendUnit',
            isRequired: true,
        },
    },
} as const;
